import isTouchDevice from "is-touch-device";
import { DOMAINS } from "./constants";

const iOS = //https://gist.github.com/Craga89/2829457
  parseFloat(
    (
      "" +
      (/CPU.*OS ([0-9_]{1,5})|(CPU like).*AppleWebKit.*Mobile/i.exec(
        navigator.userAgent
      ) || [0, ""])[1]
    )
      .replace("undefined", "3_2")
      .replace("_", ".")
      .replace("_", "")
  ) || false;

export const touchsupport = () => {
  return isTouchDevice();
};

export const promiseImage = src => {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve(image);
    if (!iOS || iOS >= 10.3) {
      image.crossOrigin = "Anonymous";
    } else if (src.indexOf("data") === -1) {
      // iOS Safari doesn't like CORS policy when src is base64
      image.crossOrigin = "Anonymous";
    }
    image.src = src;
  });
};

export const track = {
  event(category, action, label = null, value = null) {
    console.log(`event tracked: ${category} - ${action} - ${label} - ${value}`);
    window.dataLayer = window.dataLayer || [];
    if (value) {
      window.dataLayer.push({
        event: "customEvent",
        eventCategory: category,
        eventAction: action,
        eventLabel: label,
        eventValue: value
      });
    } else if (label) {
      window.dataLayer.push({
        event: "customEvent",
        eventCategory: category,
        eventAction: action,
        eventLabel: label
      });
    } else {
      window.dataLayer.push({
        event: "customEvent",
        eventCategory: category,
        eventAction: action
      });
    }
  },
  page(name) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: "pageView", pagePath: `/${name}` });
  }
};

/* eslint eqeqeq: 0  no-cond-assign: 0 */
// https://stackoverflow.com/questions/7584794/accessing-jpeg-exif-rotation-data-in-javascript-on-the-client-side/32490603#32490603
export const getOrientation = (file, resolve) => {
  return new Promise((resolve, reject) => {
    var reader = new FileReader();
    reader.onload = function(e) {
      var view = new DataView(e.target.result);
      if (view.getUint16(0, false) != 0xffd8) return resolve(-2);
      var length = view.byteLength,
        offset = 2;
      while (offset < length) {
        var marker = view.getUint16(offset, false);
        offset += 2;
        if (marker == 0xffe1) {
          if (view.getUint32((offset += 2), false) != 0x45786966)
            return resolve(-1);
          var little = view.getUint16((offset += 6), false) == 0x4949;
          offset += view.getUint32(offset + 4, little);
          var tags = view.getUint16(offset, little);
          offset += 2;
          for (var i = 0; i < tags; i++)
            if (view.getUint16(offset + i * 12, little) == 0x0112)
              return resolve(view.getUint16(offset + i * 12 + 8, little));
        } else if ((marker & 0xff00) != 0xff00) break;
        else offset += view.getUint16(offset, false);
      }
      return resolve(-1);
    };
    reader.readAsArrayBuffer(file);
  });
};

export const setCookieItem = (name,value,options)=> {
	const date = new Date();
	let defaultOptions = {
		days: 30,
		path: "/",
	};
	if (options) {
		defaultOptions = {
			...defaultOptions,
			...options,
		};
	}
	const { days, months, path = "/", domain } = defaultOptions;
	if (months && months > 0) {
		const m = date.getMonth() + months;
		if (m > 11) {
			date.setFullYear(date.getFullYear() + 1);
			date.setMonth(m - 11 - 1);
		} else {
			date.setMonth(m);
		}
	} else {
		date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
	}
	const expires = "expires=" + date.toUTCString();
	value = encodeURIComponent(value);
	document.cookie = `${name}=${value}; expires=${expires}; path=${path}; ${
		domain ? "domain=" + domain + "; " : ""
	}SameSite=None; secure`;
}


export const getEnvPublicUrl = () => {
  const currentDomain = window.location.hostname;
  switch(currentDomain) {
    case DOMAINS.LOCALHOST:
      return process.env.PUBLIC_URL_DEV;
    case DOMAINS.DEV:
      return process.env.PUBLIC_URL_DEV;
    case DOMAINS.STAGE:
      return process.env.PUBLIC_URL;
    case DOMAINS.PROD:
      return process.env.PUBLIC_URL_PROD;
    default:
      return process.env.PUBLIC_URL_PROD;
  }
}

export const getApiRoot = () => {
  const currentDomain = window.location.hostname;
  switch(currentDomain) {
    case DOMAINS.LOCALHOST:
      return process.env.REACT_APP_LOCAL_API_ROOT_DEV;
    case DOMAINS.DEV:
      return process.env.REACT_APP_LOCAL_API_ROOT_DEV;
    case DOMAINS.STAGE:
      return process.env.REACT_APP_LOCAL_API_ROOT;
    case DOMAINS.PROD:
      return process.env.REACT_APP_LOCAL_API_ROOT_PROD;
    default:
      return process.env.REACT_APP_LOCAL_API_ROOT_PROD;
  }
}

export const getHeadlessRoot = () => {
  const currentDomain = window.location.hostname;
  switch(currentDomain) {
    case DOMAINS.LOCALHOST:
      return process.env.REACT_APP_HEADLESS_NEW_ROOT;
    case DOMAINS.DEV:
      return process.env.REACT_APP_HEADLESS_NEW_ROOT;
    case DOMAINS.STAGE:
      return process.env.REACT_APP_HEADLESS_NEW_ROOT;
    case DOMAINS.PROD:
      return process.env.REACT_APP_HEADLESS_NEW_ROOT_PROD;
    default:
      return process.env.REACT_APP_HEADLESS_NEW_ROOT_PROD;
  }
}

export const getRetrievalAppLink = () => {
  const currentDomain = window.location.hostname;
  switch(currentDomain) {
    case DOMAINS.LOCALHOST:
      return process.env.REACT_APP_LABEL_RETRIVIAL_APP_LINK_DEV;
    case DOMAINS.DEV:
      return process.env.REACT_APP_LABEL_RETRIVIAL_APP_LINK_DEV;
    case DOMAINS.STAGE:
      return process.env.REACT_APP_LABEL_RETRIVIAL_APP_LINK;
    case DOMAINS.PROD:
      return process.env.REACT_APP_LABEL_RETRIVIAL_APP_LINK_PROD;
    default:
      return process.env.REACT_APP_LABEL_RETRIVIAL_APP_LINK_PROD;
  }
}



// WEBPACK FOOTER //
// ./src/misc/utils.js